<!--  -->
<template>
  <div class="activity_box">
    <div style="display:flex;justify-content: space-between;" class="search_box">
      <div class="dahdga search_box">
        <div class="operate_name">
          <el-input v-model="activityName" placeholder="请输入活动名称" />
        </div>
        <div class="choose_palte">
          <div>
            <el-select
              v-model="platform"
              class="launch"
              filterable
              placeholder="选择平台"
              @change="pirewa"
            >
              <el-option
                v-for="item in platforms"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>
        </div>
        <div class="choose_palte">
          <div>
            <el-select
              v-model="activityType"
              class="launch"
              filterable
              placeholder="选择活动类型"
              @change="pirewa"
            >
              <el-option
                v-for="item in activeforms"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>
        </div>

        <el-button type="primary" style="margin-left:10px" icon="el-icon-search" @click="serchon">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="reset">重置</el-button>

      </div>
      <div>
        <el-button icon="el-icon-circle-plus" type="success" class="add_activey" @click="addactivey">新增活动</el-button>
      </div>
    </div>

    <el-table
      v-if="tableData.length!==0"
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="platformStr"
        label="平台"
        width="180"
        align="center"
      />

      <el-table-column
        prop="activityTypeStr"
        label="活动类型"
        width="180"
        align="center"
      />
      <el-table-column
        prop="activityName"
        label="活动名称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="time_type_text"
        label="期限类型"
        width="180"
        align="center"
      />
      <el-table-column
        prop="appoint_day"
        label="固定天数"
        width="180"
        align="center"
      />
      <el-table-column
        prop="startTimeStr"
        label="开始时间"
        width="180"
        align="center"
      />

      <el-table-column
        prop="endTimeStr"
        label="结束时间"
        width="180"
        align="center"
      />
      <!-- <el-table-column
        label="预览活动页"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <div><span @click="preview(scope.row)"><el-link :underline="false" type="primary">预览</el-link></span> | 默认风格</div>
        </template>
      </el-table-column> -->
      <el-table-column
        label="操作"

        align="center"
      >
        <!-- slot-scope="scope" -->
        <template>
          <el-button type="primary">操作</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :current-page="parmrs.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      title="创建活动模板"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <addactivity ref="chooseviewr" :active-name="activeName" @readingclose="readingclose" />
    </el-dialog>
    <el-dialog
      title="预览"
      :visible.sync="previewdialogVisible"
      :destroy-on-close="true"
    >
      <preview ref="previewviewr" />
    </el-dialog>
  </div>

</template>

<script>
import addactivity from './components/addactivity.vue'
import preview from './components/preview.vue'
import { strategyPlatformthree, readingarlist } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    addactivity,
    PaginationRight,
    preview
  },
  data() {
    return {
      dialogVisible: false,
      activeName: 'second',
      platforms: [],
      platform: null, // 平台
      activityType: null, // 活动类型
      activityName: null, // 活动名称
      tableData: [],
      parmrs: {
        page: 1,
        pageSize: 10
      },
      total: null, // 总页数
      previewdialogVisible: false,

      activeforms: [
        {
          name: '充值',
          id: 1
        },
        {
          name: 'VIP',
          id: 2
        },
        {
          name: '推书',
          id: 3
        },
        {
          name: '直赠',
          id: 4
        }
      ]
      // readarr: [
      //   {
      //     text: '模板充值活动',
      //     indexrw: 'first'
      //   },
      //   {
      //     text: '模板直赠活动',
      //     indexrw: 'two'
      //   },
      //   {
      //     text: '模板消耗活动',
      //     indexrw: 'second'
      //   }

      // ],
      // sunarr: [
      //   {
      //     text: '书币充值',
      //     indexrw: 'first'
      //   },
      //   {
      //     text: 'vip充值',
      //     indexrw: 'second'
      //   }
      // ]
    }
  },
  created() {
    this.strategylist()
    this.readingarlistall()
  },
  mounted() {

  },
  methods: {
    // 获取策略列表
    async strategylist() {
      const data = await strategyPlatformthree()
      this.platforms = data.data.list
      console.log('data', data)
    },
    addactivey() {
      this.dialogVisible = true
      // eslint-disable-next-line eqeqeq
      // if (this.platform == 1) {
      //   this.$nextTick(() => {
      //     this.$refs.chooseviewr.send(this.platform, this.sunarr)
      //   })
      // }
      // // eslint-disable-next-line eqeqeq
      // if (this.platform == 2) {
      //   this.$nextTick(() => {
      //     this.$refs.chooseviewr.send(this.platform, this.readarr)
      //   })
      // }
      this.$nextTick(() => {
        this.$refs.chooseviewr.send()
      })
    },
    // 获取阅文列表
    async readingarlistall() {
      this.parmrs
      const data = await readingarlist({
        page: this.parmrs.page,
        pageSize: this.parmrs.pageSize,
        platformId: this.platform,
        activityType: this.activityType,
        activityName: this.activityName
      })
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    pirewa(val) {
      console.log('val', val)
      // eslint-disable-next-line eqeqeq
      if (val == 2) {
        // 阅文
        // this.readingarlistall()
      }
    },
    // 分页
    fetchPageSize(e) {
      this.parmrs.pageSize = e
      this.readingarlistall()
      if (this.platform === 2) {
        // this.readingarlistall()
      }
    },
    fetchCurrentPage(e) {
      this.parmrs.page = e
      this.readingarlistall()
      if (this.platform === 2) {
        // this.readingarlistall()
      }
    },
    // 重置
    reset() {
      this.parmrs.page = 1
      this.parmrs.pageSize = 10
      this.platform = null
      this.activityType = null
      this.activityName = null
      this.readingarlistall()
      if (this.platform === 2) {
        // this.readingarlistall()
      }
    },
    serchon() {
      this.readingarlistall()
    },
    readingclose() {
      this.dialogVisible = false
      this.readingarlistall()
      if (this.platform === 2) {
        // this.readingarlistall()
      }
    },
    preview(item) {
      console.log('item', item)
      this.previewdialogVisible = true
      this.$nextTick(() => {
        this.$refs.previewviewr.send(item)
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.activity_box{
  padding: 20px;
}
.choose_palte{
  display: flex;
  align-items: center;
}
.dahdga{
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.add_activey{
  margin-left: 10px;
}
.operate_box{
  display: flex;
  align-items: center;
}
@media (max-width: 768px){
  .dahdga div{
    width:100%
  }
}

</style>
